import { memo, useState } from "react";
import './ProgressiveImage.scss';

const ProgressiveImage = memo(({
    src, microSrc, alt,
    className, style,
    width, height, aspectRatio,
}: {
    src: string, microSrc: string, alt?: string,
    className?: string, style?: React.CSSProperties,
    width?: number | string,
    height?: number | string,
    aspectRatio?: string,
}) => {
    const [loaded, setLoaded] = useState(false);
    
    return <div
        className={`ProgressiveImage ${className ? className : ""} ${loaded ? "loaded" : "loading"}`}
        style={{
            ...style,
            width, height, aspectRatio,
            backgroundImage: `url(${microSrc})`,
            filter: loaded ? "blur(0px)" : "blur(20px)",
        }}
    >
        <img
            src={src}
            alt={alt}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            style={{
                width: width,
                height: height,
                opacity: loaded ? 1 : 0,
            }}
        />
    </div>;
});

export default ProgressiveImage;